import React, { useEffect, useState } from 'react'
import Table from '../Table/Table'
import Table_Buttons from '../Table_Button/Table_button'
import { API } from '../../Redux/actions/API'
import Navbar from '../Navbar/Navbar'

function Coin_price() {

    const [referralApi, setreferralApi] = useState([])
    const [leftreferralApi, setleftreferralApi] = useState([])
    const [currentPage, setcurrentPage] = useState(1)
    const [listPerpage, setlistPerpage] = useState(100)
    const [currentPage2, setcurrentPage2] = useState(1)
    const [listPerpage2, setlistPerpage2] = useState(100)
  
    const referral_API = async () => {
        try {
          let responceRight = await API?.get('/getCoinMasterReport')
          console.log('My_Team', responceRight.data.data)
          responceRight = responceRight?.data?.data
          setleftreferralApi([])
          let arrayLeft = []
          responceRight.forEach((item, index) => {
            arrayLeft.push({
              sr:index+1,
              id: `${item?.id}`,
              coin_symbol: `${item?.coin_symbol} `, 
                coin_rate: `${item?.coin_rate} `,
                coin_name:`${item?.coin_name}`,
                update:`${item?.coin_discription}`,
                type:`${item?.remark}`
                
            })
    
            setleftreferralApi(arrayLeft)
          })
        } catch (e) {
          console.log('Error While calling Myteam API', e)
        }
      }


    useEffect(() => {
      referral_API()
    }, [])
  
    const indexOfLastPost = currentPage * listPerpage
    const indexOfFirstPage = indexOfLastPost - listPerpage
    const indexOfLastPost2 = currentPage2 * listPerpage2
    const indexOfFirstPage2 = indexOfLastPost2 - listPerpage2
    const currentPost = referralApi.slice(indexOfFirstPage, indexOfLastPost)
    const currentPostleft = leftreferralApi.slice(indexOfFirstPage2, indexOfLastPost2)
  
    var [my_team, set_my_team] = new useState({
      cols: [
        { Header: 'S.No', accessor: 'sr' },
        { Header: 'Coin Name', accessor: 'coin_name' },
        { Header: 'Coin Symbol', accessor: 'coin_symbol' },
        { Header: 'Coin Type', accessor: 'type' },
        { Header: 'Coin Rate', accessor: 'coin_rate' },
        { Header: 'Description', accessor: 'update' },
        // { Header: 'Action', accessor: 'action' },

        ],
    })


   
  return (
    <div>
      <Navbar />
      <div class="content-page">
        <div class="content">
          <div class="container">
            {/* <!-- Inline Form --> */}
            <div class="row">
              <div class="col-md-12">
                <div class="panel panel-primary">
                  <div class="panel-heading">
                    <h4 class="panel-title"> Coin Details</h4>
                  </div>
                  <div class="panel-body table-rep-plugin" style={{ padding: '8px', overflowY: 'scroll' }}>
                    <div class="col-md-12">
                      <div class="row">
                        <form action="/Admin/ROIIncome" method="post" class="ng-pristine ng-valid">
                          {/* <div class="col-sm-2">
                            <input
                              class="form-control in-ip-1"
                              id="uid"
                              onChange={(e) => setSearch(e.target.value)}
                              name="uid"
                              placeholder="Enter User Id"
                              type="text"
                            />
                          </div>
                          <div class="col-sm-2">
                            <input
                              type="button"
                              id="btnsearch"
                              onClick={() => referral_API()}
                              class="btn btn-sm btn-primary"
                              value="Search"
                            />
                          </div> */}
                        </form>
                      </div>

                      <div class="row">
                        <div class="panel-heading">
                          <h4 class="panel-title"></h4>
                        </div>
                        <div
                          class="table-responsive"
                          data-pattern="priority-columns"
                          style={{ maxHeight: '500px', overflow: 'scroll' }}
                        >
                          <Table data={currentPostleft} columns={my_team.cols} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Coin_price